const areaData = {
  // cityArea.id : postcode
  1: "200",
  2: "110",
  3: "100",
  4: "104",
  5: "204",
  6: "205",
  7: "206",
  8: "202",
  9: "103",
  10: "203",
  11: "105",
  12: "106",
  13: "108",
  14: "201",
  15: "111",
  16: "112",
  17: "114",
  18: "115",
  19: "116",
  20: "208",
  21: "220",
  22: "221",
  23: "222",
  24: "223",
  25: "224",
  26: "226",
  27: "227",
  28: "228",
  29: "231",
  30: "232",
  31: "233",
  32: "234",
  33: "235",
  34: "236",
  35: "237",
  36: "238",
  37: "239",
  38: "241",
  39: "242",
  40: "243",
  41: "244",
  42: "247",
  43: "248",
  44: "249",
  45: "251",
  46: "252",
  47: "253",
  48: "207",
  49: "320",
  50: "324",
  51: "325",
  52: "326",
  53: "327",
  54: "328",
  55: "330",
  56: "333",
  57: "334",
  58: "335",
  59: "336",
  60: "337",
  61: "338",
  62: "300",
  63: "300",
  64: "300",
  65: "302",
  66: "303",
  67: "304",
  68: "305",
  69: "306",
  70: "307",
  71: "308",
  72: "310",
  73: "311",
  74: "312",
  75: "313",
  76: "314",
  77: "315",
  78: "350",
  79: "351",
  80: "352",
  81: "353",
  82: "354",
  83: "356",
  84: "357",
  85: "358",
  86: "360",
  87: "361",
  88: "362",
  89: "363",
  90: "364",
  91: "365",
  92: "366",
  93: "367",
  94: "368",
  95: "369",
  96: "400",
  97: "401",
  98: "402",
  99: "403",
  100: "404",
  101: "406",
  102: "407",
  103: "408",
  104: "411",
  105: "412",
  106: "413",
  107: "414",
  108: "420",
  109: "421",
  110: "422",
  111: "423",
  112: "424",
  113: "426",
  114: "427",
  115: "428",
  116: "429",
  117: "432",
  118: "433",
  119: "434",
  120: "435",
  121: "436",
  122: "437",
  123: "438",
  124: "439",
  125: "500",
  126: "502",
  127: "503",
  128: "504",
  129: "505",
  130: "506",
  131: "507",
  132: "508",
  133: "509",
  135: "511",
  136: "512",
  137: "513",
  138: "514",
  139: "515",
  140: "516",
  141: "520",
  142: "521",
  143: "522",
  144: "523",
  145: "524",
  146: "525",
  147: "526",
  148: "527",
  149: "528",
  150: "530",
  151: "540",
  152: "541",
  153: "542",
  154: "544",
  155: "545",
  156: "546",
  157: "551",
  158: "552",
  159: "553",
  160: "555",
  161: "556",
  162: "557",
  163: "558",
  164: "630",
  165: "631",
  166: "632",
  167: "633",
  168: "634",
  169: "635",
  170: "636",
  171: "637",
  172: "638",
  173: "640",
  174: "643",
  175: "646",
  176: "647",
  177: "648",
  178: "649",
  179: "651",
  180: "652",
  181: "653",
  182: "654",
  183: "655",
  184: "600",
  185: "600",
  186: "602",
  187: "603",
  188: "604",
  190: "606",
  191: "607",
  192: "608",
  193: "611",
  194: "612",
  195: "613",
  196: "614",
  197: "615",
  198: "616",
  199: "621",
  200: "622",
  201: "623",
  202: "624",
  203: "625",
  204: "700",
  205: "701",
  207: "704",
  208: "708",
  209: "709",
  210: "710",
  211: "711",
  212: "712",
  213: "713",
  214: "714",
  215: "715",
  216: "716",
  217: "717",
  218: "718",
  219: "719",
  220: "720",
  221: "721",
  222: "722",
  223: "723",
  224: "724",
  225: "725",
  226: "726",
  227: "727",
  228: "730",
  229: "731",
  230: "732",
  231: "733",
  232: "734",
  233: "735",
  234: "736",
  235: "737",
  236: "741",
  237: "742",
  238: "743",
  239: "744",
  240: "745",
  241: "800",
  242: "801",
  243: "802",
  244: "803",
  245: "804",
  246: "805",
  247: "806",
  248: "807",
  249: "811",
  250: "812",
  251: "813",
  252: "814",
  253: "815",
  256: "820",
  257: "821",
  258: "822",
  259: "823",
  260: "824",
  261: "825",
  262: "826",
  263: "827",
  264: "828",
  265: "829",
  266: "830",
  267: "831",
  268: "832",
  269: "833",
  270: "840",
  271: "842",
  272: "843",
  273: "844",
  274: "845",
  275: "846",
  276: "847",
  277: "848",
  279: "851",
  280: "852",
  281: "900",
  283: "902",
  284: "903",
  285: "904",
  286: "905",
  287: "906",
  288: "907",
  289: "908",
  290: "909",
  291: "911",
  292: "912",
  293: "913",
  294: "920",
  295: "921",
  296: "922",
  297: "923",
  298: "924",
  299: "925",
  300: "926",
  301: "927",
  302: "928",
  303: "929",
  304: "931",
  305: "932",
  306: "940",
  307: "941",
  308: "942",
  309: "943",
  310: "944",
  311: "945",
  312: "946",
  313: "947",
  314: "950",
  315: "951",
  316: "952",
  317: "953",
  318: "954",
  319: "955",
  320: "956",
  321: "957",
  322: "958",
  323: "959",
  324: "961",
  325: "962",
  327: "964",
  328: "965",
  329: "966",
  330: "970",
  331: "971",
  332: "972",
  333: "973",
  334: "974",
  335: "975",
  336: "976",
  337: "977",
  338: "978",
  339: "979",
  340: "981",
  341: "982",
  342: "983",
  343: "260",
  344: "261",
  345: "262",
  346: "263",
  347: "264",
  348: "265",
  349: "266",
  350: "267",
  351: "268",
  352: "269",
  353: "270",
  354: "272",
  356: "880",
  357: "881",
  358: "882",
  359: "883",
  360: "884",
  361: "885",
  362: "890",
  363: "891",
  364: "892",
  365: "893",
  366: "894",
  367: "896",
  368: "209",
  369: "210",
  370: "211",
  371: "212",
}
// {
//   中正區: 100,
//   大同區: 103,
//   中山區: 104,
//   松山區: 105,
//   大安區: 106,
//   萬華區: 108,
//   信義區: 110,
//   士林區: 111,
//   北投區: 112,
//   內湖區: 114,
//   南港區: 115,
//   文山區: 116,
//   仁愛區: 200,
//   // 信義區: 201,
//   // 中正區: 202,
//   // 中山區: 203,
//   安樂區: 204,
//   暖暖區: 205,
//   七堵區: 206,
//   萬里區: 207,
//   金山區: 208,
//   板橋區: 220,
//   汐止區: 221,
//   深坑區: 222,
//   石碇區: 223,
//   瑞芳區: 224,
//   平溪區: 226,
//   雙溪區: 227,
//   貢寮區: 228,
//   新店區: 231,
//   坪林區: 232,
//   烏來區: 233,
//   永和區: 234,
//   中和區: 235,
//   土城區: 236,
//   三峽區: 237,
//   樹林區: 238,
//   鶯歌區: 239,
//   三重區: 241,
//   新莊區: 242,
//   泰山區: 243,
//   林口區: 244,
//   蘆洲區: 247,
//   五股區: 248,
//   八里區: 249,
//   淡水區: 251,
//   三芝區: 252,
//   石門區: 253,
//   宜蘭市: 260,
//   頭城鎮: 261,
//   礁溪鄉: 262,
//   壯圍鄉: 263,
//   員山鄉: 264,
//   羅東鎮: 265,
//   三星鄉: 266,
//   大同鄉: 267,
//   五結鄉: 268,
//   冬山鄉: 269,
//   蘇澳鎮: 270,
//   南澳鄉: 272,
//   南竿鄉: 209,
//   北竿鄉: 210,
//   莒光鄉: 211,
//   東引鄉: 212,
//   // 東區: 300,
//   // 北區: 300,
//   香山區: 300,
//   竹北市: 302,
//   湖口鄉: 303,
//   新豐鄉: 304,
//   新埔鎮: 305,
//   關西鎮: 306,
//   芎林鄉: 307,
//   寶山鄉: 308,
//   竹東鎮: 310,
//   五峰鄉: 311,
//   橫山鄉: 312,
//   尖石鄉: 313,
//   北埔鄉: 314,
//   峨眉鄉: 315,
//   中壢區: 320,
//   平鎮區: 324,
//   龍潭區: 325,
//   楊梅區: 326,
//   新屋區: 327,
//   觀音區: 328,
//   桃園區: 330,
//   龜山區: 333,
//   八德區: 334,
//   大溪區: 335,
//   復興區: 336,
//   大園區: 337,
//   蘆竹區: 338,
//   竹南鎮: 350,
//   頭份市: 351,
//   三灣鄉: 352,
//   南庄鄉: 353,
//   獅潭鄉: 354,
//   後龍鎮: 356,
//   通霄鎮: 357,
//   苑裡鎮: 358,
//   苗栗市: 360,
//   造橋鄉: 361,
//   頭屋鄉: 362,
//   公館鄉: 363,
//   大湖鄉: 364,
//   泰安鄉: 365,
//   銅鑼鄉: 366,
//   三義鄉: 367,
//   西湖鄉: 368,
//   卓蘭鎮: 369,
//   // 中區: 400,
//   // 東區: 401,
//   // 南區: 402,
//   // 西區: 403,
//   // 北區: 404,
//   北屯區: 406,
//   西屯區: 407,
//   南屯區: 408,
//   太平區: 411,
//   大里區: 412,
//   霧峰區: 413,
//   烏日區: 414,
//   豐原區: 420,
//   后里區: 421,
//   石岡區: 422,
//   東勢區: 423,
//   和平區: 424,
//   新社區: 426,
//   潭子區: 427,
//   大雅區: 428,
//   神岡區: 429,
//   大肚區: 432,
//   沙鹿區: 433,
//   龍井區: 434,
//   梧棲區: 435,
//   清水區: 436,
//   大甲區: 437,
//   外埔區: 438,
//   // 大安區: 439,
//   彰化市: 500,
//   芬園鄉: 502,
//   花壇鄉: 503,
//   秀水鄉: 504,
//   鹿港鎮: 505,
//   福興鄉: 506,
//   線西鄉: 507,
//   和美鎮: 508,
//   伸港鄉: 509,
//   員林鎮: 510,
//   社頭鄉: 511,
//   永靖鄉: 512,
//   埔心鄉: 513,
//   溪湖鎮: 514,
//   大村鄉: 515,
//   埔鹽鄉: 516,
//   田中鎮: 520,
//   北斗鎮: 521,
//   田尾鄉: 522,
//   埤頭鄉: 523,
//   溪州鄉: 524,
//   竹塘鄉: 525,
//   二林鎮: 526,
//   大城鄉: 527,
//   芳苑鄉: 528,
//   二水鄉: 530,
//   南投市: 540,
//   中寮鄉: 541,
//   草屯鎮: 542,
//   國姓鄉: 544,
//   埔里鎮: 545,
//   仁愛鄉: 546,
//   名間鄉: 551,
//   集集鎮: 552,
//   水里鄉: 553,
//   魚池鄉: 555,
//   信義鄉: 556,
//   竹山鎮: 557,
//   鹿谷鄉: 558,
//   // 東區: 600,
//   // 西區: 600,
//   番路鄉: 602,
//   梅山鄉: 603,
//   竹崎鄉: 604,
//   阿里山: 605,
//   中埔鄉: 606,
//   大埔鄉: 607,
//   水上鄉: 608,
//   鹿草鄉: 611,
//   太保市: 612,
//   朴子市: 613,
//   東石鄉: 614,
//   六腳鄉: 615,
//   新港鄉: 616,
//   民雄鄉: 621,
//   大林鎮: 622,
//   溪口鄉: 623,
//   義竹鄉: 624,
//   布袋鎮: 625,
//   斗南鎮: 630,
//   大埤鄉: 631,
//   虎尾鎮: 632,
//   土庫鎮: 633,
//   褒忠鄉: 634,
//   東勢鄉: 635,
//   臺西鄉: 636,
//   崙背鄉: 637,
//   麥寮鄉: 638,
//   斗六市: 640,
//   林內鄉: 643,
//   古坑鄉: 646,
//   莿桐鄉: 647,
//   西螺鎮: 648,
//   二崙鄉: 649,
//   北港鎮: 651,
//   水林鄉: 652,
//   口湖鄉: 653,
//   四湖鄉: 654,
//   元長鄉: 655,
//   中西區: 700,
//   // 東區: 701,
//   // 南區: 702,
//   // 北區: 704,
//   安平區: 708,
//   安南區: 709,
//   永康區: 710,
//   歸仁區: 711,
//   新化區: 712,
//   左鎮區: 713,
//   玉井區: 714,
//   楠西區: 715,
//   南化區: 716,
//   仁德區: 717,
//   關廟區: 718,
//   龍崎區: 719,
//   官田區: 720,
//   麻豆區: 721,
//   佳里區: 722,
//   西港區: 723,
//   七股區: 724,
//   將軍區: 725,
//   學甲區: 726,
//   北門區: 727,
//   新營區: 730,
//   後壁區: 731,
//   白河區: 732,
//   東山區: 733,
//   六甲區: 734,
//   下營區: 735,
//   柳營區: 736,
//   鹽水區: 737,
//   善化區: 741,
//   大內區: 742,
//   山上區: 743,
//   新市區: 744,
//   安定區: 745,
//   新興區: 800,
//   前金區: 801,
//   苓雅區: 802,
//   鹽埕區: 803,
//   鼓山區: 804,
//   旗津區: 805,
//   前鎮區: 806,
//   三民區: 807,
//   楠梓區: 811,
//   小港區: 812,
//   左營區: 813,
//   仁武區: 814,
//   大社區: 815,
//   岡山區: 820,
//   路竹區: 821,
//   阿蓮區: 822,
//   田寮區: 823,
//   燕巢區: 824,
//   橋頭區: 825,
//   梓官區: 826,
//   彌陀區: 827,
//   永安區: 828,
//   湖內區: 829,
//   鳳山區: 830,
//   大寮區: 831,
//   林園區: 832,
//   鳥松區: 833,
//   大樹區: 840,
//   旗山區: 842,
//   美濃區: 843,
//   六龜區: 844,
//   內門區: 845,
//   杉林區: 846,
//   甲仙區: 847,
//   桃源區: 848,
//   那瑪夏: 849,
//   茂林區: 851,
//   茄萣區: 852,
//   屏東市: 900,
//   三地門: 901,
//   霧臺鄉: 902,
//   瑪家鄉: 903,
//   九如鄉: 904,
//   里港鄉: 905,
//   高樹鄉: 906,
//   鹽埔鄉: 907,
//   長治鄉: 908,
//   麟洛鄉: 909,
//   竹田鄉: 911,
//   內埔鄉: 912,
//   萬丹鄉: 913,
//   潮州鎮: 920,
//   泰武鄉: 921,
//   來義鄉: 922,
//   萬巒鄉: 923,
//   崁頂鄉: 924,
//   新埤鄉: 925,
//   南州鄉: 926,
//   林邊鄉: 927,
//   東港鎮: 928,
//   琉球鄉: 929,
//   佳冬鄉: 931,
//   新園鄉: 932,
//   枋寮鄉: 940,
//   枋山鄉: 941,
//   春日鄉: 942,
//   獅子鄉: 943,
//   車城鄉: 944,
//   牡丹鄉: 945,
//   恆春鎮: 946,
//   滿州鄉: 947,
//   馬公市: 880,
//   西嶼鄉: 881,
//   望安鄉: 882,
//   七美鄉: 883,
//   白沙鄉: 884,
//   湖西鄉: 885,
//   金沙鎮: 890,
//   金湖鎮: 891,
//   金寧鄉: 892,
//   金城鎮: 893,
//   烈嶼鄉: 894,
//   烏坵鄉: 896,
//   臺東市: 950,
//   綠島鄉: 951,
//   蘭嶼鄉: 952,
//   延平鄉: 953,
//   卑南鄉: 954,
//   鹿野鄉: 955,
//   關山鎮: 956,
//   海端鄉: 957,
//   池上鄉: 958,
//   東河鄉: 959,
//   成功鎮: 961,
//   長濱鄉: 962,
//   太麻里: 963,
//   金峰鄉: 964,
//   大武鄉: 965,
//   達仁鄉: 966,
//   花蓮市: 970,
//   新城鄉: 971,
//   秀林鄉: 972,
//   吉安鄉: 973,
//   壽豐鄉: 974,
//   鳳林鎮: 975,
//   光復鄉: 976,
//   豐濱鄉: 977,
//   瑞穗鄉: 978,
//   萬榮鄉: 979,
//   玉里鎮: 981,
//   卓溪鄉: 982,
//   富里鄉: 983
// }

export default areaData